// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f1d33152","239":"d94d8021","455":"b7ba0155"}[chunkId] + ".chunk.js";
};